import React, { useState } from 'react'
import { DropdownComponent, InputComponent } from '../../../components/core/Forms';
import {useReportStore} from '../../../state/useReportStore';
import { Button, SearchInput } from '../../../components/common';
import { CloseIcon } from '../../../assets/icons';
import { useExpenseSearch } from '../../../hooks';

interface InventoryFilterProps{
  handleOnChange: (e: any) => void;
  formData: any
}


const InventoryFilterForm = ( {handleOnChange, formData}: InventoryFilterProps ) => {
    const [text, setText] = React.useState('')
    const [avaliability, setAvaliability] = useState("Select Avaliablity")
    const [variation, setVariation] = useState("Select a Variation")

    const {data: searchResult, handleSearch, isSearching} = useExpenseSearch()

  return (
        <div className='flex flex-col gap-[16px] md:gap-[24px] md:flex-row justify-between  pt-[20px] xl:pt-[33px]'>
            
            <div className='280:flex 280:flex-col 280:justify-center 350:block'>
              <label>Generate by Avaliability</label>

              <DropdownComponent
                 options={[]}
                 value={avaliability}
                 selectedValue={avaliability}
                 setSelectedValue={setAvaliability}
                 dropdownClassName='280:max-w-[200px]  350:max-w-[350px] 360:ml-[0.2em] md:max-w-[276px] cursor-pointer'
                 iconClassName='mr-[2em] sm:mr-[7em] md:mr-[1.5em]'
                /> 

            </div>

            <div className='280:flex 280:flex-col 280:justify-center 350:block'>
            <label className='tex whitespace-nowrap'>Generate By Variation</label>

            <DropdownComponent
                 options={[]}
                 value={variation}
                 selectedValue={variation}
                 setSelectedValue={setVariation}
                 dropdownClassName='280:max-w-[200px]  350:max-w-[350px] 360:ml-[0.2em] md:max-w-[276px] cursor-pointer'
                 iconClassName='mr-[2em] sm:mr-[7em] md:mr-[1.5em]'
                /> 

            </div>
         </div>  
  )
}

export default InventoryFilterForm